import { useEffect, useState } from "react";
import "./App.css";
import "./bootstrap.css";
import Navbar from "./components/Navbar/Navbar";
import Board from "./components/Board/Board";
import { DragDropContext } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";
import Editable from "./components/Editable/Editable";
import useLocalStorage from "use-local-storage";
import { auth, firestore } from "./firebase";
import { doc, setDoc, getDoc } from "firebase/firestore";

function App() {
  const [data, setLocalData] = useState([]);
  const [user, setUser] = useState("");

  const setData = async (data) => {
    data = data || [];
    var currentUser = auth.currentUser;
    if (!currentUser?.uid) return;
    setLocalData(data);
    await setDoc(doc(firestore, "users", currentUser.uid), { tasks: data });
  };

  const defaultDark = window.matchMedia(
    "(prefers-colors-scheme: dark)"
  ).matches;
  const [theme, setTheme] = useLocalStorage(
    "theme",
    defaultDark ? "dark" : "light"
  );

  const switchTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  const setName = (title, bid) => {
    const index = data.findIndex((item) => item.id === bid);
    const tempData = [...data];
    tempData[index].boardName = title;
    setData(tempData);
  };

  const dragCardInBoard = (source, destination) => {
    const tempData = [...data];
    const destinationBoardIdx = tempData.findIndex(
        (item) => item.id.toString() === destination.droppableId
    );
    const sourceBoardIdx = tempData.findIndex(
        (item) => item.id.toString() === source.droppableId
    );

    const movedCard = tempData[sourceBoardIdx].card.splice(source.index, 1)[0];
    tempData[destinationBoardIdx].card.splice(destination.index, 0, movedCard);

    return tempData;
};

  const addCard = (title, bid) => {
    const index = data.findIndex((item) => item.id === bid);
    const tempData = [...data];
    tempData[index].card.push({
      id: uuidv4(),
      title: title,
      tags: [],
      task: [],
    });
    setData(tempData);
  };

  const removeCard = (boardId, cardId) => {
    const index = data.findIndex((item) => item.id === boardId);
    const tempData = [...data];
    const cardIndex = data[index].card.findIndex((item) => item.id === cardId);

    tempData[index].card.splice(cardIndex, 1);
    setData(tempData);
  };

  const addBoard = (title) => {
    const tempData = [...data];
    tempData.push({
      id: uuidv4(),
      boardName: title,
      card: [],
    });
    setData(tempData);
  };

  const removeBoard = (bid) => {
    const tempData = [...data];
    const index = data.findIndex((item) => item.id === bid);
    tempData.splice(index, 1);
    setData(tempData);
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    setData(dragCardInBoard(source, destination));
  };

  const updateCard = (bid, cid, card) => {
    const index = data.findIndex((item) => item.id === bid);
    if (index < 0) return;

    const tempBoards = [...data];
    const cards = tempBoards[index].card;

    const cardIndex = cards.findIndex((item) => item.id === cid);
    if (cardIndex < 0) return;

    tempBoards[index].card[cardIndex] = card;
    console.log(tempBoards);
    setData(tempBoards);
  };

  useEffect(() => {
    (async () => {
      var currentUser = auth?.currentUser;
      if (!currentUser?.uid) return;
      const q = await getDoc(doc(firestore, "users", currentUser?.uid));
      setLocalData(q.data()?.tasks ?? []);
    })();
  }, [setLocalData, user]);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="App" data-theme={theme}>
        <Navbar
          switchTheme={switchTheme}
          setLocalData={setLocalData}
          setUser={setUser}
        />
        <div className="app_outer">
          {user ? (
            <div className="app_boards">
              {data?.map((item) => (
                <Board
                  key={item.id}
                  id={item.id}
                  name={item.boardName}
                  card={item.card}
                  setName={setName}
                  addCard={addCard}
                  removeCard={removeCard}
                  removeBoard={removeBoard}
                  updateCard={updateCard}
                />
              ))}
              <Editable
                className={"add__board"}
                name={"Add Board"}
                btnName={"Add Board"}
                onSubmit={addBoard}
                placeholder={"Enter Board  Title"}
              />
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <h2>Please Sign In or Sign Up to create tasks</h2>
            </div>
          )}
        </div>
      </div>
    </DragDropContext>
  );
}

export default App;
